import { createSelector } from 'reselect';
import Config from 'configuration';
import { IAppState } from 'types/app';
import { IMyselfState } from 'types/myself';
import { IQuality } from 'types/qualities';

const { sidebarQualityCategories } = Config;

const getMyself = ({ myself }: IAppState) => myself;

const outputFunc = (myself: IMyselfState) => {
  const { qualities } = myself;
  return [...qualities]
    .filter(q => sidebarQualityCategories.indexOf(q.category) >= 0)
    .filter(q => q.category !== 'Skills' || !!q.cap)
    .sort(sortBySidebarOrder);
};

function sortBySidebarOrder(a: IQuality, b: IQuality) {
  return a.id - b.id;
}

export default createSelector([getMyself], outputFunc);
